import { CEInvoiceLineBase } from './ce-invoice-line-base'


export class CEInvoiceLine extends CEInvoiceLineBase {

}